// Names and emails come from the customer's Notion workspace and are untrusted;
// render as text, never markup. The id is shown because the write tools embed it
// as a people-property and comment target.

import { isString } from "../utils/schemaUtils";

export interface NotionUserItem {
  id: string;
  name: string;
  // "person" or "bot".
  type: string;
  email?: string;
}

export interface NotionUsersPayload {
  type: "notion_users";
  users: NotionUserItem[];
}

const isNotionUserItem = (v: unknown): v is NotionUserItem => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.id) && isString(r.name) && isString(r.type) && (r.email === undefined || isString(r.email));
};

export const parseNotionUsersPayload = (v: unknown): NotionUsersPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "notion_users") return null;
  if (!Array.isArray(r.users) || !r.users.every(isNotionUserItem)) return null;
  return { type: "notion_users", users: r.users };
};
